import { useOutletContext } from "react-router";

/** What `TriggerRoute` hands every page of one trigger. */
export interface TriggerRouteContext {
  /** The trigger the URL addresses, by the id at the end of its segment. */
  triggerId: string;
}

/** The id of the trigger whose page this is, from `TriggerRoute`. */
export function useTriggerRouteContext() {
  return useOutletContext<TriggerRouteContext>();
}
